export default "__VITE_ASSET__BspOz5U9__"